import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getSecondaryTextCount = async () => {
  return base.get({
    url: `${API_PARAM.SECONDARY_TEXT_COUNT}`,
  });
};

export const exportSecondaryTextGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.SECONDARY_TEXT_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.SECONDARY_TEXT),    
  });
};

export const uploadFromSecondaryText = async () => {
  return base.post({
    url: `${API_PARAM.SECONDARY_TEXT_UPLOAD}`,
  });
};